import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Tabs } from 'antd'
import _ from 'lodash'

import { devicePay } from 'utils'
import AddNewCardiFrame from '../AddNewCard/AddNewCardiFrame'
import AppiFrame from '../App/AppiFrame'
import CardPayiFrame from '../CardPay/CardPayiFrame'
import DevicePay from '../DevicePay'

class ContaineriFrame extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
    }
  }

  componentDidMount = async () => {
    this.processData()
  }

  componentDidUpdate = async (prevProps) => {
    // Re-process when data prop changes (e.g., when filtered data arrives)
    if (!_.isEqual(this.props.data, prevProps.data)) {
      this.processData()
    }
  }

  processData = async () => {
    if (this.props.data && !_.isEqual(this.state.data, this.props.data)) {
      // If skipFilter is true, data is already filtered by parent (PayPage)
      const data = this.props.skipFilter
        ? _.clone(this.props.data)
        : await devicePay.filter(_.clone(this.props.data))
      // For iframe, keep all payment methods in tabs (don't remove preferred)
      this.setState({
        data,
      })
    }
  }

  render() {
    const {
      siteConfig,
      selected,
      actions,
      submit,
      loading,
      optAddCardItems,
      optAppItems,
      pageName,
      orderLabel,
    } = this.props
    return (
      <Tabs
        destroyInactiveTabPane
        animated={false}
        className={classes.componentsPaymentMethodsContainer}
        activeKey={selected || '0'}
      >
        {this.state.data.map((item, index) => {
          const cardList = _.filter(
            item.payMethods,
            {
              type: 'PAYPAGE_CARD_PAY',
            },
            []
          )
          const canAddCard = _.filter(
            item.payMethods,
            {
              type: 'CARD_TOKEN',
            },
            []
          )

          switch (item.tabType) {
            case 'PAY_METHODS':
              return (
                <Tabs.TabPane key={index} tab>
                  {siteConfig.loginToken ? (
                    <CardPayiFrame
                      {...item}
                      actions={actions}
                      submit={submit}
                      loading={loading}
                      optAddCardItems={optAddCardItems}
                      cardList={cardList}
                      canAddCard={!!canAddCard.length}
                      pageName={pageName}
                    />
                  ) : (
                    <AddNewCardiFrame
                      {...item}
                      submit={submit}
                      loading={loading}
                      optAddCardItems={optAddCardItems}
                      pageName={pageName}
                    />
                  )}
                </Tabs.TabPane>
              )
            case 'APP':
              return (
                <Tabs.TabPane key={index} tab>
                  <AppiFrame
                    {...item}
                    submit={submit}
                    loading={loading}
                    optAppItems={optAppItems}
                    pageName={pageName}
                  />
                </Tabs.TabPane>
              )
            case 'DEVICE_PAY':
              return (
                <Tabs.TabPane key={index} tab>
                  <DevicePay
                    {...item}
                    actions={actions}
                    item={item}
                    siteConfig={siteConfig}
                    submit={submit}
                    orderLabel={orderLabel}
                  />
                </Tabs.TabPane>
              )
          }
        })}
      </Tabs>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {}
)(ContaineriFrame)

/*
  隐藏Tabs组建的标题栏，仅作为支付方式组件的容器，控制加载全部的组件，
  和PaymentMethodSelector和PaymentMethodSwitcher组合使用
*/
